<script setup lang="ts">
import "./Card.style.css"
import { cn } from "@/lib/utils"

const props = defineProps({
  class: {
    type: String,
    default: "",
  },
  margin: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div
    :class="
      cn(
        'card bg-card text-afbranding-text relative mb-22.5 flex w-auto flex-col gap-8 rounded-lg border p-4 md:mb-0 md:w-150 md:p-8 lg:w-190 lg:px-12 lg:py-8',
        props.class,
        props.margin ? 'mb-25' : ''
      )
    "
  >
    <slot />
  </div>
</template>
